/* eslint-disable radix */
import React from "react";
import { Alert, BackButton, Breadcrumbs, SendToast, Wrapper } from "@networkraildigitalfactory/components";
import { Redirect, useHistory, useParams } from "react-router-dom";
import styles from "./CreateReviewPrep.module.css";
import ReviewPrepForm from "./ReviewPrepForm";
import StatusLabel from "../StatusLabel/StatusLabel";
import { getCurrentFinancialYear } from "../../services/utils";

const CreateReviewPrep = (props) => {
  const {
    isEditing,
    user,
    setIsDraftPrep,
    isDraftPrep,
    isDirtyForm,
    setIsDirtyForm,
    setNavModalProps,
  } = props;
  const history = useHistory();
  const params = useParams();
  const { financialYear, reviewType } = params;

  const currentFY = getCurrentFinancialYear();
  const today = new Date();
  const financialYearEnd = parseInt(financialYear.split("-")[0]) + 1;
  const fyPlus3Months = new Date(financialYearEnd, 6, 6);

  if (currentFY !== financialYear.replace("-", "/") && today > fyPlus3Months) {
    SendToast("Form must be for the current financial year only", "error");
    return <Redirect to="/" />;
  }

  const goBack = () => {
    history.push("/my-performance");
  };

  return (
    <>
      <div className={styles.breadcrumbs_wrapper}>
        <Breadcrumbs
          items={[
            {
              text: "My performance",
              onClick: () => {
                if (isDirtyForm) {
                  setNavModalProps({
                    show: true,
                    navPath: "/my-performance",
                  });
                } else {
                  goBack();
                }
              },
            },
            {
              text: isEditing ? "Edit review prep" : "Start review prep",
            },
          ]}
        />
      </div>
      <Wrapper maxWidth={1350} align="center">
        <div className={styles.row}>
          <BackButton
            text="back to my performance"
            onClick={() => {
              if (isDirtyForm) {
                setNavModalProps({
                  show: true,
                  navPath: "/my-performance",
                });
              } else {
                goBack();
              }
            }}
            style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}
          />
          {isEditing && <StatusLabel status={isDraftPrep ? "Draft" : "Editing"} />}
        </div>
        {isDirtyForm && (
          <div className={styles.row}>
            <Alert
              color="red"
              title="Unsaved Changes"
              message="You must save or submit your changes before navigating to another page. If you do not select save, all changes will be lost."
              style={{
                marginBottom: "8px",
              }}
            />
          </div>
        )}
        <ReviewPrepForm
          reviewType={reviewType}
          financialYear={financialYear}
          isEditing={isEditing}
          user={user}
          setIsDirtyForm={setIsDirtyForm}
          setIsDraftPrep={setIsDraftPrep}
        />
      </Wrapper>
    </>
  );
};

export default CreateReviewPrep;
